var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',{attrs:{"leave-absolute":""}},[(_vm.loading)?_c('LoadingComponent',{attrs:{"full-page":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }